import { Stack, Flex, Button, Text, VStack, useBreakpointValue, Icon, LinkBox, LinkOverlay } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import React from 'react';

export default function WithBackgroundImage({title, backgroundImage, cta}) {
  return (
    <Flex
      w={'full'}
      backgroundImage={backgroundImage}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat">
      <VStack
        w={'full'}
        h={'500px'}
        justify={'center'}
        px={useBreakpointValue({ base: 4, md: 8 })}
        bgGradient={'linear(to-r, blackAlpha.600, transparent)'}>
        <Stack maxW="3xl" align="center" spacing={6}>
          <Text
            justify="center"
            color="white"
            whiteSpace={'pre-line'}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={useBreakpointValue({ base: '3xl', md: '4xl' })}
            fontFamily={'GerTT'}>
            {title}
          </Text>
          <LinkBox as="a">
            <LinkOverlay href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/CSC_Careers" isExternal>
              <Button
                bg="#0693e3"
                color="white"
                _hover={{ bg: 'blue.500' }}>
                Join Our Team<Icon color="white" w={5} h={5} as={ExternalLinkIcon} pl="4px"/>
              </Button>
            </LinkOverlay>
          </LinkBox>
        </Stack>
      </VStack>
    </Flex>
  );
}
